import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { FormButtons, Error, FormRow, DateFormWidget } from '../controls';

function buildDefaultValues(performance) {
  const defaultDateObject = {
    startTime: performance.startTime || null,
    endTime: performance.endTime || null,
    startTimeMS: performance.startTimeMS || null,
    endTimeMS: performance.endTimeMS || null,
  };

  return {
    performanceNotes: performance.performanceNotes || '',
    performer: performance.performer || {},
    performerId: performance.performer
      ? performance.performer.performerId || 0
      : 0,
    dates: [defaultDateObject],
  };
}

export function PerformanceForm({
  performance,
  handleSave,
  handleDateChange,
  performers,
  performerUpdated,
  handleRemove,
}) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: buildDefaultValues(performance),
    mode: 'onSubmit',
  });

  const performanceId = performance?.performanceId;

  useEffect(() => {
    reset(buildDefaultValues(performance));
  }, [performanceId, reset]);

  const dates = buildDefaultValues(performance).dates;

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <FormRow label="Performer">
        <Controller
          name="performer"
          control={control}
          rules={{
            validate: (performer) =>
              performer?.performerName ? true : 'Performer is required',
          }}
          render={({ field }) => (
            <select
              className="h-10 w-full rounded-[20px] border border-[var(--input)] px-4 outline-none"
              value={
                field.value?.performerId ? String(field.value.performerId) : ''
              }
              onChange={(e) => {
                const id = e.target.value;
                const selected = performers.find(
                  (p) => String(p.performerId) === id,
                );
                field.onChange(selected || {});
                setValue('performerId', selected?.performerId ?? 0);
                if (selected) {
                  performerUpdated(selected);
                }
              }}
            >
              <option value="">Select a performer</option>
              {performers.map((performer) => (
                <option
                  key={performer.performerId}
                  value={String(performer.performerId)}
                >
                  {performer.performerName}
                </option>
              ))}
            </select>
          )}
        />
        {errors.performer ? <Error>{errors.performer.message}</Error> : null}
      </FormRow>
      <DateFormWidget
        label="Date & Times"
        dates={dates}
        handleDateChange={handleDateChange}
        required
      />
      <FormRow label="Notes">
        <textarea
          placeholder="Performance Notes..."
          {...register('performanceNotes')}
        />
      </FormRow>
      <FormButtons
        showDelete={performance.performanceId}
        label="Performance"
        onDelete={handleRemove}
      />
    </form>
  );
}
